
import { defineComponent } from "vue";

export default defineComponent({
  name: "PictureModal",
  props: ["pictureSrc"],
  emits: ["abort"],
  setup() {
    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  },
});
